import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import Loading from '../../../common/components/Loading';
import Icon from '../../../common/icons/Icon';

class MovementSpecialistAdminBookedSessionModal extends Component {
  static propTypes = {
    loading: PropTypes.bool.isRequired,
    onCancel: PropTypes.func.isRequired,
    session: PropTypes.object.isRequired,
    toggleModal: PropTypes.func.isRequired,
    onItemComplete: PropTypes.func.isRequired,
  };

  state = {
    canceling: false,
    cancelNote: '',
  };

  cancelSession = () => {
    this.props.onCancel(this.state);
  };

  onUpdateNote = event => {
    this.setState({
      cancelNote: event.currentTarget.value,
    });
  };

  toggleCanceling = () => {
    this.setState(state => ({ canceling: !state.canceling }));
  };

  render() {
    const { loading, session, toggleModal, onItemComplete } = this.props;
    const { canceling, cancelNote } = this.state;

    if (loading) {
      return <Loading />;
    }

    if (canceling) {
      return (
        <div>
          <div className="booking-modal">
            <button className="close-button" onClick={toggleModal}>
              <Icon icon="Close" />
            </button>
            <h3>Cancel Session</h3>
            <div className="booking-textarea">
              <label>Please let the requester know why you're canceling this session</label>
              <textarea value={cancelNote} onChange={this.onUpdateNote} />
            </div>
          </div>
          <div className="modal__actions">
            <button className="button button--theme--plain" type="button" onClick={this.toggleCanceling}>
              Go Back
            </button>
            <button className="button" type="button" onClick={this.cancelSession}>
              Confirm
            </button>
          </div>
        </div>
      );
    }

    return (
      <div>
        <div className="booking-modal">
          <button className="close-button" onClick={toggleModal}>
            <Icon icon="Close" />
          </button>
          <h3>Follow up session</h3>
          {session.note && (
            <div className="booking-note">
              <i>"{session.note}"</i>
            </div>
          )}
          <div className="booking-times__wrapper" style={{ marginBottom: '0' }}>
            <p>Date & Time</p>
            <div className="booking-times">
              <strong>
                {moment(session.accepted_session_date)
                  .tz(session.time_zone_id)
                  .format('MMM D, YYYY h:mmA z')}
              </strong>
            </div>
          </div>
        </div>
        <div className="modal__actions">
          {moment(session.accepted_session_date)
            .tz(session.time_zone_id)
            .isAfter() && (
            <div>
              <button type="button" className="button button--theme--secondary" onClick={this.toggleCanceling}>
                Cancel Session
              </button>
            </div>
          )}
          {moment(session.accepted_session_date)
            .tz(session.time_zone_id)
            .isBefore() ? (
            <button type="button" className="button" onClick={() => onItemComplete(session)}>
              Complete
            </button>
          ) : null}
        </div>
      </div>
    );
  }
}

export default MovementSpecialistAdminBookedSessionModal;



// WEBPACK FOOTER //
// ./src/subscription/movement-specialist-admin/sessions/MovementSpecialistAdminBookedSessionModal.js